module.exports = __webpack_public_path__ + "static/bg_020_unicorn-3915344f0c40ebd095f5d39b0de4a1d6.webp";